// This file is generated.
export var version = '1.70.0';
//# sourceMappingURL=version.js.map